// Environment content for the deployed prod platform

export const environment = {
  production: true,
  gaEnabled: true,
  gaKey: 'UA-147463668-1',
  sentryEnabled: true,
  sentryDsn:
    'https://7c588b3549f24c4db07d7ad73b408024@glitchtip-next.sde-ild.soletanche-bachy.org/1',
  platform: 'PROD',
  featureToggle: {
    enableActivityData: true,
    enableHomePagePreferences: true,
    enableSortAsBuiltPreference: true,
    enableCsvPreference: true,
    enableCesiumMapForVisualization: false,
    enableDataScienceDwall: true,
  },
  showDialogTuto: 1,
  matomo: {
    trackerUrl: 'https://matomo.sde-ild.soletanche-bachy.org',
    siteId: 2,
  },
  azureMapsApiKey:
    'Bi0TrSGApPF3zeaFlTBccmFdB8PISOZ8lfHysEzm6RDWJzpbYuk3JQQJ99BGAC5RqLJQQOUTAAAgAZMP4flD',
}
